<template>

    <div style="margin: 100px;">
        <div class="main container">
            <el-page-header style="margin-bottom: 30px;" @back="goBack" content="资料管理">
            </el-page-header>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="合规课堂" name="first">
                    <ClassRoom :userId="id" ref="classroom"></ClassRoom>
                </el-tab-pane>
                <el-tab-pane label="合规培训" name="second">
                    <Training :userId="id" ref="training"></Training>
                </el-tab-pane>
                <el-tab-pane label="行业热点" name="third">
                    <Hotspot :userId="id" ref="hotspot"></Hotspot>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import ClassRoom from './components/classroom.vue'
import Hotspot from './components/hotspot.vue'
import Training from './components/training.vue'
export default {
    name: "classroom",
    components: {
        ClassRoom,
        Hotspot,
        Training

    },
    data() {
        return {
            id: "",
            activeName: 'first',
        };
    },

    created() {
        this.id = this.$route.query.id
    },
    methods: {
        goBack(){
            this.$router.go(-1);
        },
        handleClick(tab, event) {
            if (tab.name == 'first') {
                this.$refs.classroom.getList()
            }
            if (tab.name == 'second') {
                this.$refs.training.getList()
            }
            if (tab.name == 'third') {
                this.$refs.hotspot.getList()
            }

        },

    },

};
</script>

<style lang="scss" scoped>
.tables {
    margin-top: 50px;
}

.menu-button {
    color: #2970EC
}

::v-deep.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

::v-deep.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>
